/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promoflyertagline2Inputs */

const en_promoflyertagline2 = /** @type {(inputs: Promoflyertagline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan the code, tap Interested or plan the night with your friends right away.`)
};

const de_promoflyertagline2 = /** @type {(inputs: Promoflyertagline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan den Code, tipp auf Interessiert oder plan den Abend gleich mit deinen Freunden.`)
};

/**
* | output |
* | --- |
* | "Scan the code, tap Interested or plan the night with your friends right away." |
*
* @param {Promoflyertagline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const promoflyertagline2 = /** @type {((inputs?: Promoflyertagline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promoflyertagline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_promoflyertagline2(inputs)
	return de_promoflyertagline2(inputs)
});
export { promoflyertagline2 as "promoFlyerTagline" }